// extracted by mini-css-extract-plugin
export default {"tableContainer":"Header_tableContainer__PRwyz"};